import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=5c96ce7e&scoped=true&"
var script = {}
import style0 from "./inicio.vue?vue&type=style&index=0&id=5c96ce7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96ce7e",
  null
  
)

export default component.exports